import { render, staticRenderFns } from "./VehicleStatistics.vue?vue&type=template&id=042a34ef&scoped=true&"
import script from "./VehicleStatistics.vue?vue&type=script&lang=js&"
export * from "./VehicleStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042a34ef",
  null
  
)

export default component.exports